import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { axiosInstance } from "@retro-ia/shared/axios";
import type { CreateClienteFinalWithUserInput } from "@/lib/validaciones/createClienteFinalWithUsuario.validacion";

export const useRegisterClienteFinalWithUsuario = (options?: {
  queryKey?: string[];
}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: CreateClienteFinalWithUserInput) => {
      const response = await axiosInstance.post(
        "/clientes-finales/with-user",
        data
      );
      return response.data;
    },
    onSuccess: () => {
      if (options?.queryKey) {
        queryClient.invalidateQueries({ queryKey: options.queryKey });
      } else {
        queryClient.invalidateQueries({ queryKey: ["clientesFinales"] });
      }
      toast.success("Cliente registrado correctamente");
    },
    onError: (error) => {
      toast.error(
        error instanceof Error
          ? error.message
          : "Ocurrió un error al registrar el cliente."
      );
    },
  });
};
